// extracted by mini-css-extract-plugin
export var searchHeader = "_83-0";
export var searchHeaderDark = "_83-1";